export const SET_RANGE_INDEX = 'SET_RANGE_INDEX'
export const SET_RANGE_ATTRIBUTE = 'SET_RANGE_ATTRIBUTE'
export const SET_RANGE_FROM_TO = 'SET_RANGE_FROM_TO'
export const REMOVE_RANGE_FILTER = 'REMOVE_RANGE_FILTER'
export const REMOVE_ALL_RANGE_FILTERS = 'REMOVE_ALL_RANGE_FILTERS'
export const RESET_STATE = 'RESET_STATE'
